import React, { type FunctionComponent } from 'react'
import { PageHeader } from '@retailer-platform/shared-components'
import { NavCollectionsBreadcrumbs } from 'domains/collections/components/breadcrumbs/NavCollectionsBreadcrumbs'
import { type CollectionsRoutingConfig } from 'domains/collections/types/collections.types'

interface NavCollectionsListHeaderProps {
  routingConfig: CollectionsRoutingConfig
}

export const NavCollectionsListHeader: FunctionComponent<NavCollectionsListHeaderProps> = ({
  routingConfig,
}) => (
  <PageHeader
    addBottomPadding
    title={<NavCollectionsBreadcrumbs routingConfig={routingConfig} />}
  />
)
